import { BasicUser } from '@st/sdk'
import { formatFullNameInitials } from '@st/util/human-name'

export function formatAssigneeInitials(user: BasicUser): string {
  if (user.name) {
    return formatFullNameInitials(user.name)
  } else if (user.email) {
    return formatFullNameInitials(user.email.split('@')[0])
  }
  return ''
}
